import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Calendar } from 'lucide-react';
const articles = [{
  title: 'How to Get Your Products Listed in UK Supermarkets',
  category: 'Market Entry',
  date: 'Jan 15, 2024',
  excerpt: 'A comprehensive guide to approaching major UK retail buyers, from initial pitch to shelf placement.',
  image: 'https://images.unsplash.com/photo-1578916171728-46686eac8d58?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'EU Compliance Requirements for Food & FMCG Imports',
  category: 'Compliance',
  date: 'Dec 20, 2023',
  excerpt: 'Understanding labeling, packaging, and certification requirements for products entering the European retail market.',
  image: 'https://images.unsplash.com/photo-1552410260-0fd9b577afa6?auto=format&fit=crop&q=80&w=800'
}, {
  title: 'The Rise of Private Label Products in Global Retail',
  category: 'Industry Trends',
  date: 'Nov 8, 2023',
  excerpt: 'How private label is reshaping retail sourcing strategies and what manufacturers need to know.',
  image: 'https://images.unsplash.com/photo-1473448912268-2022ce9509d8?auto=format&fit=crop&q=80&w=800'
}];
export function InsightsSection() {
  return <section id="insights" className="py-24 bg-[#0a1628] relative" data-id="element-388">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-389">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16" data-id="element-390">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-391">
            <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-392">
              Sourcing Guides
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white" data-id="element-393">
              Sourcing Intelligence
            </h2>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-394">
          {articles.map((article, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group" data-id="element-395">
              <div className="relative h-48 mb-6 overflow-hidden border border-white/10" data-id="element-396">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover" loading="lazy" onError={e => {
              e.currentTarget.style.display = 'none';
            }} data-id="element-397" />
              </div>

              <div className="flex items-center gap-2 text-gray-500 text-xs mb-3" data-id="element-398">
                <Calendar size={12} data-id="element-399" />
                <span data-id="element-400">{article.date}</span>
              </div>

              <h3 className="text-xl font-bold text-white mb-3 leading-tight" data-id="element-401">
                {article.title}
              </h3>

              <p className="text-gray-400 text-sm leading-relaxed line-clamp-3" data-id="element-402">
                {article.excerpt}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}